import React, { useCallback } from 'react';
import { Field, getIn } from 'formik';
import { DatePicker } from 'formik-material-ui-pickers';
import moment from 'moment';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import deLocale from 'date-fns/locale/fr';
import 'moment/locale/fr';

const CustomerDatePicker = (props: any) => {
  const {
    form: { setFieldValue, values },
    field: { name },
  } = props;

  const maxDate = props.maxDateField && getIn(values, props.maxDateField);
  const minDate = props.minDateField && getIn(values, props.minDateField);

  const handleOnChange = useCallback(
    (date) => {
      setFieldValue(name, moment(date).format('YYYY-MM-DD'));
    },
    [setFieldValue, name]
  );
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={deLocale}>
      <DatePicker
        {...props}
        locale="fr"
        onChange={handleOnChange}
        maxDate={maxDate ? maxDate : undefined}
        minDate={minDate ? minDate : undefined}
      />
    </MuiPickersUtilsProvider>
  );
};

export const DateField = (props: any) => (
  <Field
    {...props}
    component={CustomerDatePicker}
    variant="inline"
    inputVariant="outlined"
    format={props.format || 'dd/MM/yyyy'}
    autoOk
    disableToolbar
  />
);

export default DateField;
